module.exports = "<div class=\"row bgHeading\"><h2>Big dates coming up</h2></div>\n<div class=\"col-12\">\n  <div class=\"col-12\" [innerHtml]=\"intro\"></div>\n  <app-calendarbox *ngFor=\"let event of dates\" [data]=\"event\"></app-calendarbox>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/dates/dates.component.html
// module id = 321
// module chunks = 1